import React from 'react'
import PropTypes from 'prop-types'
import { CustomTooltip } from '../CustomTooltip/CustomTooltip'

const ListItem = (props) => {
  let color = 'black'
  if (props.status === 'success') {
    color = 'green'
  } else if (props.status === 'danger') {
    color = 'red'
  } else if (props.status === 'doneLate') {
    color = 'orange'
  }
  const style = {
    listStyle: 'none',
    color: color
  }
  if (props.commentary && props.commentary !== 'positive' && props.commentary !== 'negative') {
    return <CustomTooltip tooltipPosition={'top'} toolTipText={props.commentary}>
      <li style={style} className={'hoverable'}>
        {props.children}
      </li>
    </CustomTooltip>
  } else {
    return <li style={style}>
      {props.children}
    </li>
  }
}

ListItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  status: PropTypes.oneOf(['success', 'danger', 'normal', 'doneLate']),
  commentary: PropTypes.string
}

export default ListItem



// WEBPACK FOOTER //
// ./src/components/common/ListItem/ListItem.js